'use strict';

import BaseService from './base.service';

export default class CitiesService extends BaseService {
  static $inject = ['City', 'SegaUser'];

  constructor(City, SegaUser) {
    super(City, SegaUser);
    Object.assign(this, {
      City
    });
  }
}
